// ProductPurchase formatter
// Handles date formatting and validation for purchase data

const validateInput = (fieldValues, Type) => {
    if (!Type || Type.type !== "ProductPurchase" || !fieldValues) return false
    return fieldValues
}

// Date formatting helpers
const formatDateForDB = (dateValue) => {
    if (!dateValue) return null
    if (dateValue instanceof Date) return dateValue
    if (typeof dateValue === 'string') {
        const date = new Date(dateValue)
        return isNaN(date.getTime()) ? null : date
    }
    // Handle MongoDB ISODate objects
    if (dateValue && dateValue.$date) {
        return new Date(dateValue.$date)
    }
    return null
}

const formatDateForUI = (dateValue) => {
    if (!dateValue) return null
    
    // Handle MongoDB ISODate objects
    if (dateValue && dateValue.$date) {
        return new Date(dateValue.$date)
    }
    
    // Keep Date objects as Date objects for proper rendering in date fields
    if (dateValue instanceof Date) return dateValue
    
    if (typeof dateValue === 'string') {
        const date = new Date(dateValue)
        return isNaN(date.getTime()) ? null : date
    }
    
    return null
}

// Main formatter
export default {
    preFormat: (fieldValues, Type) => {
        const purchase = validateInput(fieldValues, Type)
        if (!purchase) return fieldValues

        // Convert dates for form editing - ensure they're proper Date objects
        const dateFields = ['purchase_date', 'created']
        dateFields.forEach(field => {
            if (fieldValues[field]) {
                const dateValue = fieldValues[field]
                if (typeof dateValue === 'string') {
                    fieldValues[field] = new Date(dateValue)
                } else if (dateValue instanceof Date) {
                    fieldValues[field] = dateValue
                } else if (dateValue && dateValue.$date) {
                    fieldValues[field] = new Date(dateValue.$date)
                }
            }
        })

        // Ensure status is valid
        const validStatuses = ['active', 'refunded', 'revoked']
        if (fieldValues.status && !validStatuses.includes(fieldValues.status)) {
            fieldValues.status = 'active'
        }

        // Ensure required fields have defaults
        if (!fieldValues.created) {
            fieldValues.created = new Date()
        }

        if (!fieldValues.purchase_date) {
            fieldValues.purchase_date = new Date()
        }

        // Handle platform field - extract value from object format
        if (fieldValues.platform && typeof fieldValues.platform === 'object' && fieldValues.platform.value) {
            fieldValues.platform = fieldValues.platform.value
        }

        // Handle metadata field - convert array format to object
        if (Array.isArray(fieldValues.metadata)) {
            const metaObj = {}
            fieldValues.metadata.forEach(item => {
                if (item.key && item.value) {
                    metaObj[item.key] = item.value
                }
            })
            fieldValues.metadata = metaObj
        }

        // Handle price_model format - convert single object to array for editor compatibility
        if (fieldValues.price_model && !Array.isArray(fieldValues.price_model)) {
            fieldValues.price_model = [fieldValues.price_model]
        }

        return fieldValues
    },

    postFormat: (fieldValues, Type) => {
        const purchase = validateInput(fieldValues, Type)
        if (!purchase) return fieldValues

        // Convert Date objects to ISO strings for database storage
        const dateFields = ['purchase_date', 'created']
        dateFields.forEach(field => {
            if (fieldValues[field]) {
                const dateValue = fieldValues[field]
                // Convert Date objects to ISO strings
                if (dateValue instanceof Date) {
                    fieldValues[field] = dateValue.toISOString()
                } else if (typeof dateValue === 'string') {
                    // Ensure it's a valid ISO string
                    fieldValues[field] = new Date(dateValue).toISOString()
                } else if (dateValue && dateValue.$date) {
                    fieldValues[field] = new Date(dateValue.$date).toISOString()
                }
            }
        })

        // Convert populated user object back to just the ID
        if (fieldValues.user && typeof fieldValues.user === 'object' && fieldValues.user._id) {
            fieldValues.user = fieldValues.user._id
        }

        // Convert populated transaction_id object back to just the ID
        if (fieldValues.transaction_id && typeof fieldValues.transaction_id === 'object' && fieldValues.transaction_id._id) {
            fieldValues.transaction_id = fieldValues.transaction_id._id
        }

        // Convert price_model array back to single object if it has only one item
        // This maintains compatibility with existing database structure
        if (Array.isArray(fieldValues.price_model) && fieldValues.price_model.length === 1) {
            fieldValues.price_model = fieldValues.price_model[0]
        }

        // Keep metadata as object format for database
        // No conversion needed - metadata should remain as an object

        return fieldValues
    }
}